// IANA timezone of this device (e.g. "America/Chicago"). Sent at signup, login
// and on every session refresh so notifications go out at the user's local time.
export function getDeviceTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch {
        return 'UTC';
    }
}
